import { useCallback, useState } from "react";
import api from "../../services/api";

const useWhatsappTemplates = () => {
  const [loading, setLoading] = useState(false);

  const list = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const { data } = await api.get("/whatsapp-templates", { params });
      return {
        templates: data?.templates ?? [],
        count: data?.count ?? 0,
        hasMore: Boolean(data?.hasMore),
      };
    } finally {
      setLoading(false);
    }
  }, []);

  const getById = useCallback(async (id) => {
    const { data } = await api.get(`/whatsapp-templates/${id}`);
    return data;
  }, []);

  const create = useCallback(async (payload) => {
    const { data } = await api.post("/whatsapp-templates", payload);
    return data;
  }, []);

  const update = useCallback(async (id, payload) => {
    const { data } = await api.put(`/whatsapp-templates/${id}`, payload);
    return data;
  }, []);

  const remove = useCallback(async (id) => {
    await api.delete(`/whatsapp-templates/${id}`);
  }, []);

  const submit = useCallback(async (id) => {
    const { data } = await api.post(`/whatsapp-templates/${id}/submit`);
    return data;
  }, []);

  const sync = useCallback(async (whatsappId) => {
    const { data } = await api.post("/whatsapp-templates/sync", null, {
      params: { whatsappId },
    });
    return data;
  }, []);

  const uploadSample = useCallback(async (file) => {
    const formData = new FormData();
    formData.append("medias", file);
    const { data } = await api.post("/whatsapp-templates/upload-sample", formData);
    return data;
  }, []);

  return {
    loading,
    list,
    getById,
    create,
    update,
    remove,
    submit,
    sync,
    uploadSample,
  };
};

export default useWhatsappTemplates;
